//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pizzaCustomizer from '../../../common/mixins/customizer/pizzaCustomizer'

export default {
  name: 'Pizza',
  mixins: [pizzaCustomizer],
  head () {
    return {
      title: this.$getPageTitle(this.currentItem ? this.$capitalize(this.currentItem.product_type + ' - ' + this.currentItem.name) : 'pizzaCustomizer')
    }
  },
  methods: {
    notifyIngredientLimit (type) {
      this.$bvToast.toast(`You have reached the ${type} number of toppings for this Pizza!`, {
        autoHideDelay: 5000,
        appendToast: false,
        variant: 'danger',
        toastClass: 'top-notice'
      })
    }
  }
}
